import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || "https://enewsletter.onrender.com";

export default function ReadNewsletters() {
  const [newsletters, setNewsletters] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNewsletters();
  }, []);

  const fetchNewsletters = async () => {
    try {
      const res = await fetch(`${API_URL}/api/newsletters`);
      const data = await res.json();
      setNewsletters(data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p className="empty">Loading newsletters...</p>;
  }

  return (
    <div className="card">
      <h3>Newsletters</h3>

      {/* LIST VIEW */}
      {!selected && (
        <ul className="newsletter-list">
          {newsletters.map((n) => (
            <li
              key={n._id}
              className="newsletter-item"
              onClick={() => setSelected(n)}
            >
              <h4 className="newsletter-title">{n.title}</h4>
              <p className="newsletter-date">
                Scheduled on: {n.scheduleDate}
              </p>
            </li>
          ))}
        </ul>
      )}

      {/* DETAIL VIEW */}
      {selected && (
        <div className="newsletter-detail">
          <button className="back-btn" onClick={() => setSelected(null)}>
            ← Back
          </button>

          <h2>{selected.title}</h2>
          <p className="newsletter-date">
            Scheduled on: {selected.scheduleDate}
          </p>

          <hr />

          <p className="newsletter-content">{selected.content}</p>
        </div>
      )}
    </div>
  );
}
